export default [

  {
    id: null,
    label: 'Custom',
    value: null
  },
  {
    id: 'S_126',
    label: '126',
    value: 'S_126'
  },
  {
    id: 'S_163',
    label: '163',
    value: 'S_163'
  },
  {
    id: 'S_1und1',
    label: '1und1',
    value: 'S_1und1'
  },
  {
    id: 'S_AOL',
    label: 'AOL',
    value: 'S_AOL'
  },
  {
    id: 'S_DebugMail',
    label: 'DebugMail',
    value: 'S_DebugMail'
  },
  {
    id: 'S_DynectEmail',
    label: 'DynectEmail',
    value: 'S_DynectEmail'
  },
  {
    id: 'S_FastMail',
    label: 'FastMail',
    value: 'S_FastMail'
  },
  {
    id: 'S_GandiMail',
    label: 'GandiMail',
    value: 'S_GandiMail'
  },
  {
    id: 'S_Gmail',
    label: 'Gmail',
    value: 'S_Gmail'
  },
  {
    id: 'S_Godaddy',
    label: 'Godaddy',
    value: 'S_Godaddy'
  },
  {
    id: 'S_GodaddyAsia',
    label: 'GodaddyAsia',
    value: 'S_GodaddyAsia'
  },
  {
    id: 'S_GodaddyEurope',
    label: 'GodaddyEurope',
    value: 'S_GodaddyEurope'
  },
  {
    id: 'S_hot__ee',
    label: 'hot__ee',
    value: 'S_hot__ee'
  },
  {
    id: 'S_Hotmail',
    label: 'Hotmail',
    value: 'S_Hotmail'
  },
  {
    id: 'S_iCloud',
    label: 'iCloud',
    value: 'S_iCloud'
  },
  {
    id: 'S_mail__ee',
    label: 'mail__ee',
    value: 'S_mail__ee'
  },
  {
    id: 'S_Mail__ru',
    label: 'Mail__ru',
    value: 'S_Mail__ru'
  },
  {
    id: 'S_Maildev',
    label: 'Maildev',
    value: 'S_Maildev'
  },
  {
    id: 'S_Mailgun',
    label: 'Mailgun',
    value: 'S_Mailgun'
  },
  {
    id: 'S_Mailjet',
    label: 'Mailjet',
    value: 'S_Mailjet'
  },
  {
    id: 'S_Mailosaur',
    label: 'Mailosaur',
    value: 'S_Mailosaur'
  },
  {
    id: 'S_Mandrill',
    label: 'Mandrill',
    value: 'S_Mandrill'
  },
  {
    id: 'S_Naver',
    label: 'Naver',
    value: 'S_Naver'
  },
  {
    id: 'S_OpenMailBox',
    label: 'OpenMailBox',
    value: 'S_OpenMailBox'
  },
  {
    id: 'S_Outlook365',
    label: 'Outlook365',
    value: 'S_Outlook365'
  },
  {
    id: 'S_Postmark',
    label: 'Postmark',
    value: 'S_Postmark'
  },
  {
    id: 'S_QQ',
    label: 'QQ',
    value: 'S_QQ'
  },
  {
    id: 'S_QQex',
    label: 'QQex',
    value: 'S_QQex'
  },
  {
    id: 'S_SendCloud',
    label: 'SendCloud',
    value: 'S_SendCloud'
  },
  {
    id: 'S_SendGrid',
    label: 'SendGrid',
    value: 'S_SendGrid'
  },
  {
    id: 'S_Mailosaur',
    label: 'Mailosaur',
    value: 'S_Mailosaur'
  },
  {
    id: 'S_Mandrill',
    label: 'Mandrill',
    value: 'S_Mandrill'
  },
  {
    id: 'S_Naver',
    label: 'Naver',
    value: 'S_Naver'
  },
  {
    id: 'S_OpenMailBox',
    label: 'OpenMailBox',
    value: 'S_OpenMailBox'
  },
  {
    id: 'S_Outlook365',
    label: 'Outlook365',
    value: 'S_Outlook365'
  },
  {
    id: 'S_Postmark',
    label: 'Postmark',
    value: 'S_Postmark'
  },
  {
    id: 'S_QQ',
    label: 'QQ',
    value: 'S_QQ'
  },
  {
    id: 'S_QQex',
    label: 'QQex',
    value: 'S_QQex'
  },
  {
    id: 'S_SendCloud',
    label: 'SendCloud',
    value: 'S_SendCloud'
  },
  {
    id: 'S_SendGrid',
    label: 'SendGrid',
    value: 'S_SendGrid'
  },
  {
    id: 'S_SendinBlue',
    label: 'SendinBlue',
    value: 'S_SendinBlue'
  },
  {
    id: 'S_SendPulse',
    label: 'SendPulse',
    value: 'S_SendPulse'
  },
  {
    id: 'S_SES',
    label: 'SES',
    value: 'S_SES'
  },
  {
    id: 'S_SES___US___EAST___1',
    label: 'SES-US-EAST-1',
    value: 'S_SES___US___EAST___1'
  },
  {
    id: 'S_SES___US___WEST___2',
    label: 'SES-US-WEST-2',
    value: 'S_SES___US___WEST___2'
  },
  {
    id: 'S_SES___EU___WEST___1',
    label: 'SES-EU-WEST-1',
    value: 'S_SES___EU___WEST___1'
  },
  {
    id: 'S_Sparkpost',
    label: 'Sparkpost',
    value: 'S_Sparkpost'
  },
  {
    id: 'S_Yahoo',
    label: 'Yahoo',
    value: 'S_Yahoo'
  },
  {
    id: 'S_Yandex',
    label: 'Yandex',
    value: 'S_Yandex'
  },
  {
    id: 'S_Zoho',
    label: 'Zoho',
    value: 'S_Zoho'
  },
  {
    id: 'S_qiye__aliyun',
    label: 'qiye__aliyun',
    value: 'S_qiye__aliyun'
  },
]